/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AltText({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M2.75 5.6c-.614 0-1.01.452-1.252.914-.106.202-.148.462-.148.796v1.465h2.8V7.31c0-.334-.041-.594-.148-.796C3.76 6.052 3.364 5.6 2.75 5.6m1.4 4.375V12a.6.6 0 1 0 1.2 0V7.31c0-.409-.046-.899-.286-1.354C4.764 5.385 4.06 4.4 2.75 4.4S.736 5.385.436 5.956C.196 6.41.15 6.9.15 7.31V12a.6.6 0 1 0 1.2 0V9.975zM7.35 4.4a.6.6 0 0 1 .6.6v6.4h2.9a.6.6 0 0 1 0 1.2h-3.5a.6.6 0 0 1-.6-.6V5a.6.6 0 0 1 .6-.6m3.3.6a.6.6 0 0 1 .6-.6h4a.6.6 0 1 1 0 1.2H14.1V12a.6.6 0 1 1-1.2 0V5.6h-1.65a.6.6 0 0 1-.6-.6" clipRule="evenodd" /></svg>;
}
;